<template>
  <div class="sdiv dinline-block vtop cpointer prelative br10 ofhidden mb20 tleft" @click="goRoute(item.id)">
    <img class="trans3" :src="item.image" width="305" height="160" />
    <div class="txt pabsolute twhite fs14 p100">
      <div class="cur pabsolute br50 bgw tcenter trans3"></div>
      <div class="stxt">
        <div class="fs20 fbold nm trans3">{{item.name}}</div>
        <div class="mt5 int trans3">{{item.short_description}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "edu-img-item",
  props:[
    'controller',
    'item',
    'index',
  ],
  methods:{
    goRoute(id){
      this.$router.push({path:'/'+this.controller+'/professional/detail',query:{id:id}})
    },
  }
}
</script>

<style scoped>
  .dsdiv .sdiv:nth-child(4n + 1){margin-left: 0;}
  .dsdiv .sdiv:nth-child(4n){margin-right: 0;}
  .dsdiv .sdiv:hover{margin-top: -5px;}
  .dsdiv .sdiv:hover .nm{color: #063674;}
  .dsdiv .sdiv:hover .cur{background: #063674;}
  .dsdiv .sdiv:hover .int{color: #fff;}
  .dsdiv .sdiv:hover .cur::before{border-color: #fff;}
  .dsdiv .stxt{padding: 20px 10px 0 38px;}
  .dsdiv .cur{left: 10px;top: 25px;width: 20px;height: 20px;}
  .dsdiv .cur::before{content: '';position: absolute;left: 6px;top: 6px;transform: rotateZ(135deg);border-radius: 1px;width: 7px;height: 7px;border-top: 1px solid #5f82b5;border-left: 1px solid #5f82b5;}
</style>



// WEBPACK FOOTER //
// src/components/index/edu-img-item.vue